window.addEventListener('load', () => {
  let companies_offices = document.getElementsByClassName('companies-offices')[0]
  let branch_office_contents = Array.from(document.getElementsByClassName('companies-office__detail'))

  if(!companies_offices || branch_office_contents.length == 0) return

  let maxHeight = 0
  // 住所等の情報とリンクの矢印部分を合わせた最大の高さを取得する
  branch_office_contents.forEach(branch_office_content => {
    let height = branch_office_content.clientHeight
    if(height > maxHeight){
      maxHeight = height
    }
  })

  // カセットに高さをセットする
  branch_office_contents.forEach(branch_office_content => {
    branch_office_content.style.height = maxHeight + 'px'
  })

  // 高さのセットが終わったら非表示にしていたスタイルを外す
  companies_offices.removeAttribute("style")
})
